module.exports = __webpack_public_path__ + "media/images/flags/GS-0d9a43fca10cf403f96bacfa4d512591.svg";